import { RouteLoadingShell } from "@/components/portal/route-loading-shell";

export default function LegacyFinancialModelLoading() {
  return <RouteLoadingShell variant="model" />;
}
